import { CoachCard } from '../concept/coach-card';

/**
 * Cadence, stated rather than forecast.
 *
 * The source concept said "78 % mot målet · ca 6–8 veckor". Nothing in the
 * data computes the weeks, so they are not shown; what is shown is the scan
 * interval, which is an instruction rather than a prediction.
 */
export const NextStepCard: React.FC<{ lastScan?: Date; className?: string }> = ({
  lastScan,
  className,
}) => {
  const weeksSince = lastScan
    ? Math.floor((Date.now() - lastScan.getTime()) / (7 * 24 * 3600 * 1000))
    : null;

  return (
    <CoachCard title="Next step" testId="next-step" className={className}>
      <div className="flex flex-col gap-1 text-[12.5px] leading-relaxed">
        <div>Continue current plan</div>
        <div className="text-foreground-soft">
          {weeksSince === null
            ? 'Next scan in 2–4 weeks'
            : weeksSince >= 4
              ? `Last scan ${weeksSince} weeks ago — due now`
              : `Next scan in ${Math.max(1, 4 - weeksSince)}–${Math.max(2, 6 - weeksSince)} weeks`}
        </div>
      </div>
    </CoachCard>
  );
};
